"use client"

// import React from "react";
import "./AboutPage.css"
import heroImage from "../../assets/sharp.jpeg"
import sandDredgingImage from "../../assets/SIMDOZI-PNGArtboard-1.png"
import missionImage from "../../assets/SIMDOZI-PNGArtboard-2.png"
import safetyImage1 from "../../assets/SIMDOZI-PNGArtboard-4.png"
//import managementImage2 from "../../assets/felicia.jpeg";
//import managementImage3 from "../../assets/patner2.jpeg";
//import managementImage1 from "../../assets/chief.png";
import TextFade from "../../components/CustomTexts/TextFade"
import TextEffect from "../../components/CustomTexts/TextEffect"
import organogramImage from "../../assets/Artboard 1.png"
import profileImg from "../../assets/ceo.jpeg"
// import chysonImg from "../../assets/chysonfries.jpg";
// import farmImg from "../../assets/cut.png";
// import supplyImg from "../../assets/pink.jpg";
// import consultancyImg from "../../assets/industry.jpg"
// import establishmentImg from "../../assets/grass.jpg";
// import { Link } from "react-router-dom";
//import ClientStrategy from "../../components/Others/ClientStrategy"
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { motion } from "framer-motion";


const AboutPage = () => {
  return (
    <div className="about-container">
      <div className="hero-bg1" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="hero-overlay"></div>
        <div className="hero-content1">
          <TextEffect text="About Us" className="hero-title" />
        </div>
      </div>

      <div className="flex px-[5%] md:flex-row flex-col justify-between items-center md:mt-0 mt-20 md:gap-0 gap-20">
        <div className="relative md:w-[30%] w-full">
        <img
  src={sandDredgingImage || "/head.svg"}
  alt="About Us"
  className="w-full md:w-auto md:absolute top-[-40vh] left-0 z-[1] object-cover"
/>
        </div>
        <div className="md:w-[55%] w-full md:mt-32">
          <TextFade animation="fade-down">
            <h1 className="md:text-[60px] text-[30px] font-bold text-dark mb-20"><TextEffect text3="Who we are" /></h1>
          </TextFade>
          <p className="text-dark md:text-[20px] text-[14px] w-full">
            Established in 2017 and commencing operations in 2021, we specialize in the production, processing, and
            promotion of micronutrient-rich food crops, particularly Orange-Fleshed Sweet Potato (OFSP) and
            Purple-Fleshed Sweet Potato (PFSP). Simdozi International Limited is a forward-thinking, nutrition-sensitive
            agriculture company dedicated to quality, sustainability, and innovation in the food and agriculture sector.
          </p>
          <p className="text-dark md:text-[20px] text-[14px] w-full mt-10">
            Simdozi International is registered as limited a liability company under the Corporate and Allied Matters
            Act (1999) of Corporate Affairs Commission on 8th March, 2017 with the <b> "Registration Number":{" "}
             1396389 </b>to provide agricultural services to interested publics. It started operations in 2021.
          </p>
        </div>
      </div>

      <div className="flex md:mt-[150px] mt-20 flex-col w-full px-[5%] pb-32">
        <TextFade animation="fade-down">
          <h1 className="md:text-[60px] text-[30px] font-bold text-dark mb-10"><TextEffect text3="What We Stand For" /></h1>
        </TextFade>
        <p className="text-dark md:text-[20px] text-[14px] w-full">
          Through modern agricultural practices, ethical sourcing, and innovative processing methods, we are redefining
          the food industry by ensuring access to high-quality, nutritious, and sustainable food products. Thereby
          improving the productivity of Nigerians by boosting their health through what they eat, making healthy food
          crops available, affordable and accessible through local production of these food crops in every community
          thereby contributing to the GDP of the nation.
        </p>
        <p className="text-dark md:text-[20px] text-[14px] w-full mt-10">
          Through establishment of farms, processing centres, and conducting community sensitizations and capacity
          building trainings as well as facilitate business connections for the value chain.
        </p>
      </div>

      <div className="bg-dark px-[5%] py-32">
        <div className="">
          <TextFade animation="fade-down">
            <h1 className="md:text-[60px] text-[30px] font-bold text-light mb-10">MISSION STATEMENT </h1>
          </TextFade>
          <p className="text-light md:text-[20px] text-[14px] w-full">
            Popularizing the Production, Processing, and Utilization of Vitamin-rich Food Crops.
          </p>
          <p className="text-light md:text-[20px] text-[14px] w-full mt-10">
            To popularize the production, processing and utilization of food crops that are rich in micronutrients like
            Vitamin A, C, B, D, E and other essential minerals. <br /> Using Orange Fleshed Sweet Potato and Purple
            Fleshed Sweet Potato as our flagship to drive this Mission.
          </p>
        </div>

        <div className="mt-32 flex md:flex-row flex-col justify-between items-center gap-20">
          <div className="md:w-[35%] w-full">
            <img src={missionImage || ""} alt="Mission" className="w-80 h-80 mr-8" />
          </div>

          <div className="md:w-[55%] w-full">
            {" "}
            <TextFade animation="fade-down">
              <h1 className="md:text-[60px] text-[30px] font-bold text-light mb-10">VISION STATEMENT </h1>
            </TextFade>
            <div className="sub1">
              <p className="text-light md:text-[20px] text-[14px] w-full">
                Sustainable Agriculture and Food Security in Africa and Beyond{" "}
              </p>
            </div>
            <p className="text-light md:text-[20px] text-[14px] w-full mt-10">
              To contribute to winning the war against food and nutrition shortage by providing high nutrient food crops
              that are accessible, affordable and sustainable through adoption of resilient climate friendly innovations
              and technologies.
            </p>
          </div>
        </div>
      </div>

      <div className="our-history">
        <h3 className="history-title">Our Methodology</h3>
        <div className="flex items-center justify-center mb-20 px-[5%] mt-20">
          <div className="flex flex-col items-center justify-center md:w-[460px] w-[100%]">
            {" "}
            <div className="text-[25px] font-extrabold md:text-[31px] text-light"></div>
            <div className="text-[40px] font-extrabold md:text-[80px] text-light leading-[80px] justify-center">
              Processing Centres
            </div>
            <p className="text-light md:text-[20px] text-[14px] w-full text-center">
              {" "}
              Designing and developing one-of-a-kind designs specific to your vision.
            </p>
          </div>
        </div>
        <div className=" w-full flex md:flex-row flex-col justify-between px-[5%] items-start md:gap-0 gap-20">
          <div className="flex flex-col items-center justify-center md:w-[460px] w-[100%]">
            <h6 className="text-[25px] font-extrabold md:text-[31px] text-light"></h6>
            <div className="text-[40px] font-extrabold md:text-[80px] text-light leading-[80px]">
              Establishment of Farms
            </div>
            <p className="text-light md:text-[20px] text-[14px] w-full text-center">
              Committed to delivering exceptional support and attention to detail.
            </p>
          </div>
          <div className="flex flex-col items-center justify-center md:w-[460px] w-[100%]">
            {" "}
            <div className="text-[25px] font-extrabold md:text-[31px] text-light"></div>
            <div className="text-[40px] font-extrabold md:text-[80px] text-light leading-[80px]">
              Standard Materials
            </div>
            <p className="text-light md:text-[20px] text-[14px] w-full text-center">
              {" "}
              Utilizing high-quality materials for durable and reliable results
            </p>
          </div>
        </div>
      </div>

    {/* Organogram Section */}
<div className="px-[5%] py-20">
<h1 className="management-title text-center text-[30px] md:text-[60px] font-bold text-dark mb-10"><TextEffect part="Meet the Simdozi Team" /></h1>

  <div className="flex justify-center items-center w-full">
    <a
      href={organogramImage}
      target="_blank"
      rel="noopener noreferrer"
      className="transition-transform transform hover:scale-105 hover:shadow-2xl"
    >
      <img
        src={organogramImage}
        alt="Simdozi Organogram"
        className="w-full max-w-5xl rounded-xl shadow-lg cursor-pointer"
      />
    </a>
  </div>
</div>

      <div className=" bg-dark py-20 px-[5%] flex md:flex-row flex-col  justify-between items-center md:gap-0 gap-20">
        <div className="md:w-[50%] w-full ">
          <TextFade animation="fade-down">
            <h1 className="md:text-[60px] text-[30px] font-bold text-light mb-10">
            <TextEffect text1="Chyson Foods – Our Food Processing Subsidiary" />{" "}
            </h1>
          </TextFade>
          <p className="text-light md:text-[20px] text-[14px] w-full">
            Under our subsidiary Chyson Foods, we process and distribute a range of nutritious OFSP-based products,
            including:
            <div className="chyson-bullets mt-10 space-y-10 relative">
              {[
                "Fresh OFSP tubers",
                "OFSP fermented flour",
                "OFSP regular flour",
                "OFSP bread and bakery products",
                "OFSP dried chips",
                "OFSP crispy granules",
                "OFSP fresh fries",
              ].map((item, index) => (
                <div key={index} className="bullet-item flex items-start gap-4 relative">
                  <div className="bullet-indicator relative">
                    <div className="bullet-circle bg-green-700 w-4 h-4 rounded-full z-10"></div>
                    {index < 6 && (
                      <div className="bullet-line absolute top-4 left-1/2 transform -translate-x-1/2 h-10 w-[2px] bg-green-500 z-0"></div>
                    )}
                  </div>
                  <p className="text-light text-[16px] md:text-[20px]">{item}</p>
                </div>
              ))}
            </div>
          </p>
        </div>
        <div className="md:w-[35%] w-full">
          <img
            src={safetyImage1 || "/placeholder.svg"}
            alt="Safe Environment 1"
            className="w-[80%] md:w-[400px] mx-auto"
          />
        </div>
      </div>
      <div className="profile-section flex flex-col md:flex-row items-start justify-between px-[5%] py-20 gap-10 bg-[#f7f7f7]">
      <div className="flex flex-col md:flex-row gap-10 items-start w-full">

        {/* Profile Info */}
        <motion.div
          className="w-full md:w-1/2"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h1 className="md:text-[60px] text-[30px] font-bold text-dark mb-10">
            <TextEffect part="Meet Our Leader" />
          </h1>
          <div className="mb-6 w-full max-w-[500px]">
          <img
            src={profileImg}
            alt="Mr. Esonu Udeala"
            className="rounded-xl w-full aspect-square object-cover"
          />
</div>
          <h2 className="text-2xl md:text-3xl font-bold text-dark mb-1">
            Mr. Esonu Nduka Udeala
          </h2>
          <h3 className="text-md text-primary font-semibold mb-4">
            CEO/Director, Research and Value Chain Development
          </h3>
          <p className="text-[17px] text-gray-700 mb-4">
            Meet Mr. Esonu Udeala – A Leader in Agribusiness & Food Security!
          </p>
          <p className="text-[17px] text-gray-700 mb-4">
            Drawing on many years of experience in agricultural value chains and rural development, Mr. Esonu has impacted farmers across Nigeria, championing sustainable agribusiness and nutrition-sensitive farming. From leading cassava value chain innovations to empowering rural communities, his work continues to transform the sector.
          </p>
          <p className="text-[17px] text-gray-700">
            With an MBA in Marketing and extensive training in agricultural value chains, he has empowered farmers nationwide, promoted nutrition-sensitive farming, and led major cassava value chain projects across 18 states.
          </p>
        </motion.div>

        {/* Social Media Slider */}
        <motion.div
          className="w-full md:w-1/2"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h1 className="md:text-[60px] text-[30px] font-bold text-dark mb-10">
            <TextEffect part="Recent Posts" />
          </h1>

          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={20}
            slidesPerView={1}
            navigation
            pagination={false}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            className="rounded-xl"
          >
            {[
                {
    src: "https://www.facebook.com/plugins/post.php?href=https://web.facebook.com/esonu.udeala/posts/pfbid02Bcfhm1xwidbyz63URGTTdUGsan5c8ba4EJoxGK44eKL52132HDVP62JEiqd7p4xzl?rdid=jlK9eWwnhLl0arHg&show_text=true&width=500",
    caption: "📸 Recent photos from Onne project.",
  },
   {
    src: "https://player.vimeo.com/video/1125159858?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
    caption: "🌍 Watch this Address. It will help you appreciate the great impact of Orange Fleshed Sweet Potato in Africa.",
  },
  {
    src: "https://www.facebook.com/plugins/post.php?href=https://web.facebook.com/esonu.udeala/posts/pfbid0drjHwaxyzgU9kyCi1fN5YEjuEWUdFa2ejcw57xYiSBRx9cSgHKJomdBVoavLcFael?rdid=mwadkyRQI02Pxjt5&show_text=true&width=500",
    caption: "📸 Recent photos from West Africa Container Terminal (WACT) – Rivers State Project.",
  },
  {
    src: "https://www.facebook.com/plugins/post.php?href=https://web.facebook.com/esonu.udeala/posts/pfbid02hMyUXawiB7TFcmVrw2CuVvd2KxZbabokdBGfiRCmWtScRHBM7iR9X33F1NvKbvpul?rdid=V2MoKLfybcyUZTkT&show_text=true&width=500",
    caption: "🌱 Crop Farming Roundtable at Brickspoint Boutique Aparthotel, Abuja – June 18th, 2025.",
  },
  {
    src: "https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2F1251475206%2Fposts%2F10227047691918835&show_text=true&width=500",
    caption: "📢 Highlighting the successful distribution of Orange Fleshed Sweet Potatoes to rural farmers.",
  },
  {
    src: "https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2F1251475206%2Fposts%2F10227772380715602&show_text=true&width=500",
    caption: "🌱 Community training on sweet potato value addition and sustainable agribusiness practices.",
  },
  {
    src: "https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2F1251475206%2Fposts%2F10227029000171553&show_text=true&width=500",
    caption: "👨‍🌾 Empowering youth in agriculture with new farming technologies and business models.",
  },
  {
    src: "https://www.linkedin.com/posts/agropgroup_meet-mr-esonu-udeala-a-leader-in-agribusiness-activity-7313212756038447105-RPEG?utm_source=share&utm_medium=member_desktop&rcm=ACoAADiZdvIBgF_brZ746rRA1qIreVaHqn4eKVk",
    caption: "Meet Mr. Esonu Udeala – A Leader in Agribusiness & Food Security! 🚜🍽️.",
  },
  {
    src: "https://www.linkedin.com/posts/esonu-udeala-a4b32a20b_pdf-anti-bacterial-phytochemical-analysis-activity-7317956005479223296-bWM5?utm_source=share&utm_medium=member_desktop&rcm=ACoAADiZdvIBgF_brZ746rRA1qIreVaHqn4eKVk",
    caption: "🌍 Anti-Bacterial, Phytochemical Analysis and Blood Pressure, Lowering Effects of Orange Flesh Sweet Potatoes.",
  }
].map(({ src, caption }, idx) => (
  <SwiperSlide key={idx}>
    <div className="rounded-xl w-full h-[450px] overflow-hidden mb-4">
      <iframe
        className="w-full h-full"
        src={src}
        width="100%"
        height="450"
        style={{ border: "none", overflow: "hidden" }}
        scrolling="no"
        frameBorder="0"
        allow="encrypted-media"
        allowFullScreen
        title={`Post ${idx + 1}`}
      ></iframe>
    </div>
    <p className="text-[16px] text-gray-700 text-center px-4">{caption}</p>
  </SwiperSlide>
))}

          </Swiper>
        </motion.div>

      </div>
    </div>
          </div>
  )
}

export default AboutPage
